import { useContext } from 'react';
import { Text } from 'components';
import { useColumnHeaders } from 'domain/hooks/useApiList';
import { NotificationLog } from 'domain/models';
import { dateTimeFormat } from 'domain/utils/date.utils';
import { CardListContext } from 'pages/base/CardList';

export const AdminAlertRow = ({ item }: { item: NotificationLog }) => {
	const { rel } = useContext(CardListContext);
	const columns = useColumnHeaders<NotificationLog>(rel);
	if (!item || !columns) {
		return <></>;
	}
	return (
		<>
			{columns.map((key, index) => (
				<td key={`td-${key as string}-${index}`} className={'text-center'}>
					<Text>{render(item, key)}</Text>
				</td>
			))}
		</>
	);
};

const render = (value: NotificationLog, field: string): string => {
	switch (field) {
		case 'sendTime':
			return dateTimeFormat(value[field]);
		case 'addressee':
			return `${value.usernameDestination} - ${value.emailDestination}`;
		default:
			return (value as any)[field]?.toString();
	}
};
